<template>
  <div class="page flex-col">
    <div class="block_1 flex-row justify-between">
      <div class="box_1 flex-col justify-between">
        <div class="section_1 flex-row">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng477c9042038d7decac1a8ee9ee932b2758b9c391fb075013211b297e0dbd266f.png"
          />
          <div class="text-wrapper_1 flex-col justify-between">
            <span class="text_1">刷题</span>
            <span class="text_2">200题精选</span>
          </div>
        </div>
        <div class="section_2 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPnga44b131e28d649fc0d36334b02c6f3ac976484ae5c9ddb871e2e98106a07fad7.png"
          />
          <div class="text-wrapper_2 flex-col justify-between">
            <span class="text_3">模拟考试</span>
            <span class="text_4">加油！祝您成功</span>
          </div>
        </div>
      </div>
      <div class="box_2 flex-col">
        <span class="text_5">等待结果</span>
        <span class="text_6">面试官正在加急批卷…</span>
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng0f373d8b4229421ce66abca54a611ce05c3a2c99564ca9ef7b02f7a5c02fa116.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />